var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h53.3v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bf0000",
    d: "M29.2 26.6v.1l.1.2-.1-.2-.3-.2-.2-.2V26l.2.2.2.2zm-.8-.5v.2h-.2v-.2zm.7.8-.6.2-.1-.2.5-.2h-.4l-.1-.2v-.1h.3l.2.2zm-.4-.4h-.2v.1zm-.7 0h-.3v-.1zm.6.6h-.5l-.2.1-.1-.1.2-.1h-.1l-.1-.2.2-.1h.3v.2h.2zm-.7.1h-.3l-.1-.2v-.2h-.1l-.1-.1v-.2h.2v.3l.2.2h.2zm-.5-.6-.1.1H27l.1-.2zm.1.7H27v-.1zV27h-.2v-.2l.2.1v.2zm-.5 0h-1.3v-.2h.3l.1-.1h.1v.1h.4l.1-.1v.1h.2V27h.1v.1zm-1-.7v.1h-.5l.2-.1h.4m-.3.7h-.6V27l.6.1v-.3l.1.2v.1zm-.5 0-.1-.1-.1-.1v-.2l.1-.2v-.1l.2-.2v.3l-.2.3h.2zm-.3-.7h-.4l.3-.2zm0 .5-.2.1h-.6l-.3-.2.2-.2.3-.1-.2.1-.1.1v.2l.5.1h.2V27l.3-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 24.6v.2h-.1v-.3h-.1V24l.1.2zm.6-.4v.2h-.1v.4-.2l-.1-.2-.1-.1V24h.1v.1zm.6.4v.2H27v-.3h-.2v-.3h.2v.3zm.5 0v.2zl-.1-.3-.2.5v-.5l.1-.2.1.2.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M0 0h53.3v40H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    fillRule: "evenodd",
    d: "M35.6 0h17.7v40H35.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bf0000",
    fillRule: "evenodd",
    d: "M17.8 0h17.8v40H17.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M28.4 22.3h.7q0 .5.4.7h-1.4q.3-.3.3-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m23.7 18 .4.5h5l.5-.4h-1.3l-.6-.5h-2l-.7.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M25.8 17.6h1.7q.4-.2.3-.8 0-1-.9-1h-.2v-.3l-.1.2-.2.2a1 1 0 0 0-1 1q0 .4.4.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23 23.8h7.4l-.7-.5h-6.1zm3.4-2.1v.5h.4zm-.2.5v.4h.4l-.1-.4zm.6 0 .2.4h.6l-.4-.4zm-3 .9q.4-.4.4-.8h.7l.1.3h.7v-.4h-.5V20c0-.8 1-1.3 1.3-1.3h-2.3 5-2.4Q28 19 28 20v.6-.6c0-.6-.8-1.2-1.4-1.2s-1.4.5-1.4 1.2v.2h1.3v.2l.1.1.4.1v.4h.3v.4l.4.1v.4l.2.1v.4l.3.2h-.7l.4.4h-.6l-.3-.4h-.5l.2.4h-.4l-.1-.4h-.6v.5zm1.9-1.4v.5h.5l-.1-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "m26.5 22.2-.1-.5h.1l.3.5m-.3 0h.3m-.3 0 .1.4h-.3m.2-.4h-.3m.6 0 .2.4h.6l-.4-.4zm-.6 0v.4m0-.4h-.5v-.5h.4zm0 .4.2.4h.4l-.2-.4h.5l.3.4h.6l-.4-.4h.7l-.3-.2V22l-.2-.1v-.4l-.4-.1V21l-.3-.1v-.4h-.4l-.1-.2v-.2h-1.3V20c0-.7.8-1.2 1.4-1.2q1.1.2 1.3 1.2v.6h.1V20q-.1-1.1-1.3-1.3H29h-4.9 2.3c-.4 0-1.3.5-1.3 1.3v2.2h.5v.4H25l-.1-.3h-.7q0 .4-.5.8h2v-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M25.7 21h.3v.7h-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M25.3 21.8h.3v-.5q0-.5.3-.5l.2.4v.6h.3v-1.3h-1zm2.3.2h.3v.3h-.3zm-.2-.4h.3v.3h-.3zM27 21h.4v.3H27zm-.3-.4h.4v.3h-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M26.5 21.8h.4l.6.5V22l-.2-.2v-.2l-.3-.2v-.3l-.3-.1v-.4l-.2-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M28 21h.1v.5zm-5.1-2.2c-.1-.2-.3.3-.7.6q-.3.3-.4.7v.9l.6.6.2-.7q0-.4.3-.8l.5-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bf0000",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "m22.9 20.2-.2-.3-.2-.1-.2-.2v-.3h-.1l-.4.8v.4h.4l.3.3.1.2q0-.5.3-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22.2 19.3q0 .4.3.5t.4.4m-1 .1q0 .3.3.3.3.1.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22.7 18.6h.1l1.6 2.6h-.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22.9 18.5a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0zm1.4-2.1h.6v.1h-.6zm0 .3h.6v1.2h-.6zm0-.5h.6q0-.4-.3-.5-.3.1-.4.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd6b00",
    fillRule: "evenodd",
    d: "m26 16-.3.5v.6h.1v-.5l.3-.4V16m0 .1h.1l-.3.5v.5l-.1-.1v-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd6b00",
    fillRule: "evenodd",
    d: "m26.2 16.3-.2.3v.7h.2v-.5q0-.3.2-.4v-.1zm0 0h.2l-.3.4v.5H26v-.6q0-.3.3-.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M24.2 18.9h.7v1h-.7zm0 1.5h.7v.2h-.6zm0 .4h.8v.8h-.8zm0 1h.8v.4h-.8zm0-1.6h.7l.1-.2h-.8zm1-.7V19h.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M24.3 19.7h.2v-.5h.2v.5q0 .2.1 0v-.6c0-.2-.5-.2-.5 0zm0 1.2h.5v.6h-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.6 21.2h.2zm-.3 0h.2zm.2-.3h.1v.3zm0 .3h.1v.3zm-2.8-6.6q0 .8-.4.7 0-.4.4-.7m-.6 1c-.2 0 0-1 0-1.3q.2 1 0 1.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M24.6 21.2h.2-.2m0 0v-.3.3m0 0v.3-.3m0 0h-.3.2m-2.8-6.6q0 .8-.4.7 0-.4.4-.7zm-.6 1c-.2 0 0-1 0-1.3q.2 1 0 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M21.2 15.7c.4.2.7-.3.8-.7zm-.3.5c-.3-.1-.1-1 0-1.4 0 .4.2 1.2 0 1.4zm.1 0q.1-.4.6-.5 0 .4-.6.5zm-.3.4c-.3 0-.2-1.1-.2-1.5.1.3.4 1.4.2 1.5zm0 0q.6 0 .7-.4-.4 0-.6.4zm-.3.4q-.3-.2-.1-1.6c0 .7.4 1.4.1 1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M20.5 17q.4.2.7-.4c-.4.2-.6 0-.7.4zm2.3-2q0 .7-.5.7 0-.4.5-.7zm-.7 1.1q.5.1.9-.7c-.4.3-1 .4-.9.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22 16.1q-.3-.4.2-1 0 .7-.2 1zm-.1.5q.1-.4.6-.5c0 .1-.1.6-.6.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M21.8 16.6q-.4-.2 0-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M21.5 17q-.3-.3 0-.9c0 .4.3.7 0 1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M21.6 17q.4.4.7-.5-.6.3-.7.5zm-.9 1.8c0-.4.3-1 0-1.5h.2l.2.3.2-.5.2.1v.3l.3-.2q.1 0 0 .1-.6.4-1 1.4zm-.7 5.7q.4 1 1.3.8t1.4-.6a1 1 0 0 1 1-.1h.2l-.4-.4q-.5-.3-1.1-.3l-1.5.6zm4.2 1.1q.2.1.2 0v-.3q-.3.2-.2.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m19.6 18.5.1-.2h.5V18h.3q.6.8.8 1.7.2.6-.3 1.2 0-.4-.2-.7c-.2-.4-.8-1.3-1.2-1.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M21 21.2c.3 0 .4-.5.4-.6q-.4 0-.4.6zm3 4.6c.3 0 .3-.6 0-.8.1.4-.2.7 0 .8zm-.1 0c0 .3-.7 0-.9-.3.4.2.9 0 .9.3zm-.3-.4c0 .2-.6 0-.8-.2q.7 0 .8.2zm.1 0c.3 0 .2-.6 0-.8.1.4-.2.7 0 .8zm-.3-.4q.4-.2 0-.7zm0 0c0 .3-.6.1-.8-.2l.7.2zm-.2-.2q.2-.3-.3-.4 0 .4.3.4zm1.2 1.3c0 .3-.7.1-1-.2q.9 0 1 .2zm-2.9-.5c0 .3-.7 0-1-.3q.9 0 1 .3zm.5.1q.2-.2-.4-.5 0 .5.4.5zm0 .2c.1.3-.8.1-1-.1q1.1 0 1 .1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22.5 26c0 .3-.7.3-1 .1.4 0 1-.2 1 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22.9 26.3c0 .2-.7.2-1 0 .4 0 .9-.3 1 0zm.5 0c.2.3-.6.3-.9.2q.7-.2 1-.1zm-1-.4c-.2.2-.2-.3-.4-.6q.7.4.5.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M23 26.1c-.3.2-.5-.5-.6-.8q.6.6.5.8zm.5.2c-.1.2-.7-.6-.9-1 .3.3 1 .8 1 1zm-.5.6c0 .3-1.4-.3-1.6-.6.8.4 1.6.3 1.6.6zm-4.3-6.5c0 .2.1.9.5 1.1l2 .6q.5 0 .8.5l-.2-.9q-.2-.5-.7-.5-1 0-1.8-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M21.8 23q.4.2.2-.7l-.2.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22 23.5q.3 0 .2-.7c0 .4-.4.6-.2.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22.2 23.8c.2.2.3-.3.1-.6 0 .4-.3.5-.1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M22.1 23.9c0 .2-.6-.3-.7-.5.3.3.8.2.7.5zm-.2-.4c-.1.2-.8-.5-1-.8zm-.2-.5c0 .3-.8-.5-1-.8.3.4 1.1.6 1 .8zm0-.3q.3 0-.3-.6 0 .6.3.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "m21.3 22.5-.4-.4q0 .4.4.4zm1.2 1.4q.2 0 0-.5zm-3-1.8c-.3.2-.8-.6-1-.9.3.4 1 .7 1 .9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M19.7 22.5c-.1.2-.7-.3-.8-.6.2.3.9.3.8.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M20 22.9c0 .2-.8-.4-1-.6.3.3 1 .3 1 .6zm-.1.2c-.1.2-.7-.3-.9-.6.4.3 1 .4.9.6zm-.3-1v-.7q-.2.5 0 .6zm.2.3c.4 0 0-.4 0-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M20 22.8q.4-.1 0-.9zm0 .6c-.1.3-.8-.3-1-.6.4.3 1 .4 1 .6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M20.4 23.9c-.1.2-.8-.3-1-.6.4.3 1 .3 1 .6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M20.8 24.3c-.1.4-.9-.2-1-.5.4.3 1 .2 1 .5zm-.7-1c.2.1.3-.5.2-.9 0 .5-.4.8-.2 1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M20.4 23.8q.4-.2 0-1zm.5.4q.3-.2-.2-.8 0 .7.2.8zm-.5.2q0 .2-.6-.3zm-.2-4.6q.3-.4 0-1c0 .4-.3.8 0 1zm0 .4q-.5-.2-.3-.8.3.4.3.9zm.1 0q.4-.1.3-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M20.3 20.6q-.4 0-.5-.6c.3.4.5.3.5.6zm0 0q.4 0 .3-.6l-.2.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M19.9 20.5q0 .5.4.5 0-.3-.4-.5zm.5.5q0-.2.3-.5 0 .6-.3.6zm-1-2.5q.1-.4-.1-1-.2.6 0 1zm0 .4c-.4 0-.5-.7-.6-1q.5.5.5 1zm0 0 .3-.6q-.4.2-.3.6zm-.1.5c-.3 0-.6-.8-.6-1.1.1.4.7.6.6 1zm0 0q.5-.2.4-.7-.4.3-.3.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M19.3 19.8c-.4 0-.4-.6-.7-1 .3.3.8.8.7 1zm.1 0q.4-.2.3-.7c0 .2-.4.4-.3.7zm-.7-.5q.2.9.6 1c.1-.3-.2-.3-.6-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "m19.4 20.2.3-.6q0 .7-.3.6zm-.6-.3c.2.4.3 1 .6.9.1-.4-.3-.4-.6-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M19.5 20.7c-.2-.2.2-.3.3-.6q0 .7-.3.6zm.6-3q.4 0 .4-.6-.4 0-.4.6zm-.7-.2h.1v-.8h-.1zm2 1.4q-.1.1 0-.2l.2-.3q0-.4.2-.6t0 .1v.5zm-.2-.2q-.2.1-.2-.2l.2-.4.3-.4q.2 0 .1.1l-.3.4zm-1.4-.7q0 .4.1 0-.2-.3 0-1v-.7l-.2.1v1.7zm.4-1q-.1.3-.2 0v-1h.2v1.2zm-1.4 3.4q.1 0 0-.1V20l-.2-.3v.3zm1.8 2.1.4.6.1.7-.2-.6q0-.4-.3-.7zm.4.6q.3.2.4.5l.1.5q-.2.1-.3-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.7 25.6q0 .4.3.4 0-.2-.3-.4m.3 0q.5.2.6.4-.4 0-.6-.3m-1.5-1q.4.2.5.6t.3.7l-.5-.6q0-.4-.3-.8m.3 0q.5.2.6.6t.2.7q-.3-.2-.4-.6 0-.4-.4-.8m.8.6V25h.5v.2H26l-.2.1h-.1zm1 0V25h-.4v.2l.3.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M30.5 18.8c0-.2.2.3.6.6q.3.3.4.7v.9l-.5.6c-.1.1-.2-.4-.3-.7q0-.4-.3-.8l-.5-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bf0000",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "m30.5 20.2.1-.3.2-.1q.2 0 .2-.2h.1v-.3l.4.8v.4H31l-.2.3-.2.2q0-.5-.2-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M31.1 19.3q0 .4-.3.5t-.3.4m1 .1q0 .3-.4.3l-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "m30.6 18.6-1.7 2.6h.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M30.4 18.5a.2.2 0 1 0 .4 0 .2.2 0 0 0-.4 0zm-1.3-2.1h-.6v.1h.6zm0 .3h-.6v1.2h.6zm0-.5h-.7q0-.4.4-.5.2.1.3.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd6b00",
    fillRule: "evenodd",
    d: "M27.3 16q.3.2.3.5v.6h-.1v-.5q0-.3-.3-.4V16zm0 .1.2.5v.5h.1v-.6q0-.3-.3-.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd6b00",
    fillRule: "evenodd",
    d: "m27.1 16.3.3.3v.5q0 .3-.2.2v-.5l-.2-.4zm0 0H27l.2.4v.5h.2v-.6q0-.3-.3-.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M29.1 18.9h-.7v1h.7zm0 1.5h-.7v.2h.7zm0 .4h-.7v.8h.7zm0 1h-.7v.4h.8zm0-1.6h-.7V20h.8zm-.9-.7V19h-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M29 19.7h-.1v-.5h-.2v.5q-.1.2-.2 0v-.6c0-.2.5-.2.5 0zm0 1.2h-.5v.6h.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.7 21.2h-.2zm.3 0h-.2zm-.2-.3h-.1v.3h.1zm0 .3h-.1v.3h.1zm2.8-6.6q0 .8.4.7.1-.4-.4-.7m.6 1c.2 0 0-1 0-1.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M28.7 21.2h-.2.2m0 0v-.3h.1v.3m-.1 0h.1m-.1 0h.1m-.1 0v.3h.1v-.3m0 0h.2-.2m2.8-6.6q0 .8.4.7.1-.4-.4-.7zm.6 1c.2 0 0-1 0-1.3z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M32.1 15.7c-.4.2-.7-.3-.8-.7.3.4.9.4.8.7zm.3.5c.3-.1.1-1 0-1.4 0 .4-.2 1.2 0 1.4zm0 0q-.2-.4-.7-.5 0 .4.6.5zm.3.4c.3 0 .1-1.1.1-1.5 0 .3-.3 1.4-.1 1.5zm-.2 0q-.4 0-.6-.4.5 0 .6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M33 17c.2 0 0-.8 0-1.6 0 .7-.3 1.4 0 1.6zm-.2 0q-.4.2-.6-.4c.3.2.6 0 .6.4zm-2.3-2q.2.7.5.7.1-.4-.5-.7zm.7 1.1q-.5.1-.9-.7.9.3 1 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M31.4 16.1q.2-.4-.2-1-.1.7.2 1zm0 .5q-.1-.4-.6-.5c0 .1.2.6.7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M31.6 16.6q.4-.2 0-1c0 .5-.3.8 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M31.8 17c.4-.1.1-.6 0-.9v1zm-.1 0q-.4.4-.6-.5zm.9 1.8c0-.4-.3-1 0-1.5h-.2l-.2.3-.2-.5-.1.1v.3l-.3-.2q-.2 0-.1.1.6.4 1 1.4zm.8 5.7c-.5.7-.6.9-1.4.8s-.9-.3-1.4-.6a1 1 0 0 0-1-.1h-.1q0-.3.3-.4l1.2-.3 1.5.6zM29 25.6q0 .1-.2 0v-.3q.4.2.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.7 18.5v-.2H33V18q0-.1-.2 0l-.9 1.7q0 .6.3 1.2l.2-.7c.2-.4.8-1.3 1.2-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M32.4 21.2c-.4 0-.4-.5-.4-.6q.3 0 .4.6zm-3 4.6c-.3 0-.3-.6 0-.8-.2.4.1.7 0 .8zm0 0c0 .3.7 0 1-.3-.5.2-1 0-1 .3zm.3-.4c0 .2.7 0 .9-.2q-.7 0-.9.2zm0 0c-.3 0-.3-.6 0-.8-.2.4.1.7 0 .8zm.2-.4q-.3-.2 0-.7zm.1 0q.2.4.7-.2zm.2-.2q-.2-.3.3-.4 0 .4-.3.4zm-1.3 1.3c0 .3.7.1 1-.2q-.9 0-1 .2zm2.9-.5c0 .3.8 0 1-.3q-.9 0-1 .3zm-.5.1q-.1-.2.5-.5-.1.5-.5.5zm0 .2c0 .3.8.1 1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M30.9 26c-.1.3.7.3 1 .1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M30.5 26.3c-.1.2.6.2 1 0-.5 0-1-.3-1 0zm-.6 0c-.1.3.7.3 1 .2q-.8-.2-1-.1zm1-.4c.2.2.2-.3.4-.6q-.6.4-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M30.4 26.1c.2.2.4-.5.6-.8-.3.3-.8.7-.6.8zm-.6.2c.2.2.7-.6.9-1-.3.3-1 .8-.9 1zm.5.6c.1.3 1.4-.3 1.6-.6-.8.4-1.6.3-1.6.6zm4.3-6.5h.1c0 .2-.2.9-.5 1.1s-1.5.5-2.1.6q-.5 0-.8.5l.3-.9q.1-.5.7-.5.9 0 1.7-.3.4-.2.6-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M31.5 23q-.4.2-.2-.7c0 .4.4.6.2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M31.3 23.5q-.3 0-.1-.7c0 .4.4.6.1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M31.1 23.8c-.2.2-.3-.3-.1-.6q.2.5.1.6zm.1.1c.1.2.7-.3.8-.5q-.7.3-.8.5zm.3-.4c0 .2.8-.5.9-.8zm.1-.5c.1.3.8-.5 1-.8-.3.4-1 .6-1 .8zm0-.3q-.2 0 .4-.6.1.6-.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "m32 22.5.4-.4q0 .4-.3.4zM30.9 24q-.2 0 0-.5zm3-1.8c.4.2.8-.6 1-.9-.3.4-1 .7-1 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M33.6 22.5c.2.2.7-.3.9-.6-.3.3-1 .3-.9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M33.3 22.9c0 .2.8-.4 1-.6-.3.3-1 .3-1 .6zm.1.2c.2.2.8-.3 1-.6q-.9.4-1 .6zm.4-1q-.2-.3 0-.7.2.5 0 .6zm-.3.3c-.4 0 0-.4 0-.8q.2.8 0 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M33.3 22.8q-.4-.1 0-.9.2.7 0 .9zm0 .6c.2.3.8-.3 1-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M33 23.9c0 .2.8-.3 1-.6-.4.3-1.1.3-1 .6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M32.5 24.3c.1.4 1-.2 1.1-.5-.5.3-1.1.2-1 .5zm.7-1c-.2.1-.2-.5-.1-.9 0 .5.4.8.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M32.9 23.8q-.4-.2 0-1 .2.6 0 1zm-.5.4q-.2-.2.2-.8 0 .7-.2.8zm.5.2q.1.2.7-.3zm.2-4.6c-.3-.2 0-.6 0-1 0 .4.3.8 0 1zm0 .4q.4-.2.3-.8c0 .4-.4.5-.3.9zm0 0q-.5-.1-.4-.8.4.4.3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M33 20.6q.4 0 .5-.6c-.2.4-.5.3-.4.6zm0 0q-.5 0-.3-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M33.5 20.5q0 .5-.5.5.1-.3.5-.5zm-.5.5-.4-.5q-.1.6.4.6zm1-2.5q-.2-.4 0-1 .3.6 0 1zm0 .4c.4 0 .5-.7.5-1zm0 0q-.3-.3-.3-.6.3.2.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M34 19.4c.4 0 .6-.8.6-1.1 0 .4-.6.6-.6 1zm0 0q-.5-.2-.3-.7.3.3.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M34 19.8c.4 0 .4-.6.7-1-.2.3-.8.8-.7 1zm0 0q-.5-.2-.4-.7c0 .2.4.4.3.7zm.7-.5q-.3.9-.7 1c-.1-.3.3-.3.7-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "m34 20.2-.4-.6q0 .7.3.6zm.6-.3c-.3.4-.4 1-.7.9 0-.4.4-.4.7-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#bd6b00",
    strokeWidth: 0.1,
    d: "M33.9 20.7q0-.2-.4-.6-.1.7.4.6zm-.7-3q-.4 0-.3-.6.3 0 .3.6zm.7-.2V17q-.2-.1 0-.4zm-2 1.4q.3.1.1-.2l-.2-.3-.2-.6-.2.1.2.5q0 .2.3.5zm.3-.2q.1.1.1-.2l-.1-.4-.4-.4q-.2 0 0 .1l.2.4q0 .3.2.5zm1.4-.7q-.1.4-.2 0l.1-1v-.7q.1-.1.1.1v1.7zm-.4-1q0 .3.1 0v-1h-.1v1.2zm1.4 3.4q-.2 0-.1-.1V20l.2-.3v.3zm-1.8 2.1-.4.6-.2.7q.3-.1.3-.6zm-.5.6-.4.5v.5q.2.1.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.6 25.6q0 .4-.3.4 0-.2.3-.4m-.2 0-.7.4q.4 0 .7-.3m1.4-1q-.3.2-.4.6l-.4.7q.4-.2.5-.6t.3-.8m-.3 0-.5.6q0 .4-.3.7.4-.2.4-.6zm-.8.6V25h-.4v.2l.3.1zm-1 0 .1-.1h.3v.2l-.2.1h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.2 27.7v.2l-1.1.1q-.4.1-.2-.2zm-5.1 0v.2q.6-.1 1.2.2.3 0 .2-.2l-.4-.2zm.3-2-.3.2-1.2 1c-.1.1-.3.3.3.5l.7.2q.2.1 0 .2v.3q.7-.2 1.4.1l.4-.1.2-.4h1.5q.2.1.3.4h1.8l-.1-.2v-.3q1.5-.2 1-.7l-1.2-1q0-.3-.3-.1-1 .4-2.3.5-1.1 0-2.2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bd6b00",
    d: "M29 25.8q-1.1.5-2.3.5a6 6 0 0 1-2.2-.5h-.2l-1 1q-.2.1 0 .2c.7.3 1.4.7 3.5.7 2 0 2.8-.5 3.4-.7h.2v-.2q-.8-.4-1.1-1zm0 0h.1l1 1h.1v.1c-.7.3-1.5.8-3.5.8s-2.8-.5-3.5-.7v-.2l1-1h.2a6 6 0 0 0 2.2.6 7 7 0 0 0 2.4-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 12.4h.1l.5 1.1q0 .4-.3.6h-.6l-.1-.4s.1.4.3.4q.5-.1.6-.5c0-.3-.5-.8-.5-1.2m.8.9.1.1v-.1m.2-.3H25q0-.3.3-.4v.1zm1-1h.3l-.2.1m.5 0 .2-.2-.2.3m-.4.3v.1h.2v-.1zm-.6.5q-.1-.2.1 0c.3 0-.3.8-.6 1q-.2.1 0 0l.5-.7zm1.3-.6.2-.1q.2.2-.1.3l-.4.3h.7q.2.1 0 .2h-.5l-.3.4.2-.4h-.3v-.2l.4-.4zm.5 0 .1-.1v.2zm.6-.1v.1zm-.2.4.1.1h.3l-.1-.2-.1.1zm-.8.6v.4l.5-.5q0-.2 0 0v.6l.4-.1v-.6q0-.1.1 0v.6q.1.2.3 0V13q0-.1.2 0v.4q0 .4-.3.4l-.3-.2-.3.2c-.3 0-.1-.5-.2-.5s-.2.5-.4.4l-.2-.5q.1-.2.2 0m1.5-.7q-.2-.2 0-.2l.4.6.1-.4q.1-.2.2 0l-.2.6.3.7h-.1l-.2-.5-.2.6q0 .2-.1 0l.2-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.6 13.9.1.1q.5 0 .7-.3l.2-.7q.2-.2.1-.4h-.1l-.3 1q-.1.3-.7.3m.6-1.1H29a.1.1 0 0 0 .1.2l.2-.1zm0-.2h.4zm.8.2q.3-.2.2 0l-.6 1zm-.7 1.2q.1.5.6.2l.1.4.4-.2.6-1v-.2q-.4.8-.8 1.2-.2.1-.2-.2 0-.2-.2-.1h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.2 13.4-.1.1q.2 0 0 0m-.2.4h.3zm-5.5-1.4.1.1zm-.5.9h.1q.4 0 .7-.6l.2-.3q.2.2.3 0h.3V12v.1h-.2q-.1.2-.3 0 0-.2-.1 0l-.3.3q0-.2-.2-.3-.3.1-.1.4h.3q-.1.4-.7.7m-2 1.2.1.1v-.1zm.3.4h.2v-.5l.4.3.4-.4q.3 0 .2-.3t-.4-.4q-.1-.2 0 .1l.2.4h-.1l-.4-.3.2.4-.1.3-.4-.3h-.1v.5q0 .2-.1 0m-.4-.8.2-.3h-.3l.2.1zm.4-.7s0 .2.1.1zm.1.3h.2q.2 0 .2-.3l-.2-.1v.2zm.5-.8-.1.2zm.2 0q0-.3.2 0l.6.8q0 .2-.1.1zm.5 0 .2-.4h-.2zm6.9.3.1-.2c.2.2.3 1 .4 1.6 0-.2-.2-1.2-.5-1.4m-4.7-.8q0-.3.1-.1.2.8.6 1.2.1.2-.1.1L26 13s-.3.4-.8.3l-.1-.6q0 .4.3.5t.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.6 14.5.6-1.1v.3l-.5 1v-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.5 13.7c0-.3.3 0 .1.3q-.3.7-.9 1l-.4-.2h.6q.5-.5.6-1m-5 1.2h-.2v.3q0 .3-.1 0V15zm0-.2-.4.3v.2h-.3l-.2.2q-.2-.1 0-.2l.2-.2.1.1.1-.2zm.4.4v.2l.1-.1s0 .3.2.1h.3V15l-.1.2V15h-.1v.2q-.2 0-.1-.1zm.8-.2.2-.2v.2l-.1.4zm-.4-.3v.2zm-.7-.9-.1.5-.2-.3v.3L26 14l.2.5-.4-.3.2.3-.6-.4.4.5-.5-.3.3.3-.8-.3.8.4q.5-.3 1.1-.2t1.1.2l.8-.4-.8.3.4-.3-.5.3.4-.5-.7.4.2-.3-.3.2.1-.4-.4.4V14l-.1.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf);
export default __webpack_public_path__ + "static/media/af.a166d29f60454965bbc3863ad96fbaa0.svg";
export { ForwardRef as ReactComponent };